export default __webpack_public_path__ + "static/media/background.843ae49b.jpg";